import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


function closeSpotlight() {
  var data = { formulario: "Cerrar", elemento: "X" };
  var dataJson = JSON.stringify(data);
  window.chrome?.webview?.postMessage(dataJson);
  return false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    onClick: closeSpotlight,
    class: "icon_header feather feather-x",
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#555",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_3))
}
}

})